import React, { PureComponent } from 'react';
import styled from 'styled-components';

import withIsMobile from '../../context/withIsMobile';

const OfflineMessageContainer = withIsMobile(styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 30px;
  padding: 6px 20px;
  box-sizing: border-box;
  z-index: 900;

  background-color: #f5a623;

  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
  transition: background-color 0.5s ease;
  ${props =>
    !props.isMobile &&
    `
    height: 30px;
  `};

  ${props =>
    props.online &&
    `background-color: #7ca74b;
    opacity: 0;
    transition: display 2s, opacity 2s linear;`};
`);
class OfflineMessage extends PureComponent {
  state = { showOfflineMessage: true };

  componentDidUpdate(prevProps) {
    this.handleOnlineChange(prevProps);
  }

  componentDidMount() {
    this.handleOnlineChange({ online: false });
  }

  handleOnlineChange = prevProps => {
    const { online } = this.props;
    const prevOnline = prevProps.online;

    if (!prevOnline && online) {
      this.setState({ showOfflineMessage: true });
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.setState({ showOfflineMessage: false });
      }, 2000);
    } else if (prevOnline && !online) {
      this.setState({ showOfflineMessage: true });
    }
  };

  render() {
    const { online } = this.props;
    const { showOfflineMessage } = this.state;

    if (!showOfflineMessage) {
      return null;
    }

    const message = online ? 'Connected' : 'Connecting…';

    return <OfflineMessageContainer online={online}>{message}</OfflineMessageContainer>;
  }
}

export default OfflineMessage;



// WEBPACK FOOTER //
// ./src/components/MetaMessages/OfflineMessage.js